/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment-timezone';
import * as TYPES from './action-types';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';
const intialState = {
  successMessage: null,
  errorPopupMessage: null,
  loading: false,
  searchCheckFromDisplay: false,
  checkData: [],
  referenceData: null,
  systemParameter: null,
  clickOnMaintainCheckOption: false,
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.DISPLAY_CHECK_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.DISPLAY_CHECK_SUCCESS_MESSAGE:
      return { ...state, successMessage: action.payload };
    case TYPES.DISPLAY_CHECK_ERROR_POPUP_MESSAGE:
      return { ...state, errorPopupMessage: action.payload };
    case TYPES.SEARCH_CHECK_FROM_DISPLAY:
      return { ...state, searchCheckFromDisplay: action.payload };
    case TYPES.DISPLAY_CHECK_TABLE_DATA:
      return {
        ...state,
        checkData:
          action.payload.length > 0
            ? action.payload?.map((item) => {
                item.batchDt = item.batchDt
                  ? moment(item?.batchDt).format('MM/DD/YYYY')
                  : null;
                item.checkDt = item.checkDt
                  ? moment(item?.checkDt).format('MM/DD/YYYY')
                  : null;
                item.postmarkedDt = item.postmarkedDt
                  ? moment(item?.postmarkedDt).format('MM/DD/YYYY')
                  : null;
                item.receivedDt = item.receivedDt
                  ? moment(item?.receivedDt).format('MM/DD/YYYY')
                  : null;
                if (!item.totAllocatedAmt?.toString()?.includes('$'))
                  item.totAllocatedAmt = item.totAllocatedAmt
                    ? handleCommaSeparatedAmount(item.totAllocatedAmt)
                    : `$ ${parseFloat(0).toFixed(2)}`;
                if (!item.checkAmt?.toString()?.includes('$'))
                  item.checkAmt = item.checkAmt
                    ? handleCommaSeparatedAmount(item.checkAmt)
                    : `$ ${parseFloat(0).toFixed(2)}`;
                return item;
              })
            : [],
      };
    case TYPES.DISPLAY_CHECK_REFERNCE_DATA:
      return { ...state, referenceData: action.payload };
    case TYPES.DISPLAY_CHECK_SYSTEM_PARAMETER:
      return { ...state, systemParameter: action.payload };
    case TYPES.CLICK_ON_MAINTAIN_CHECK:
      return { ...state, clickOnMaintainCheckOption: action.payload };
    default:
      return state;
  }
};

export default reducer;
